import { createTheme } from '@mui/material/styles';
import type { PaletteOptions, ThemeOptions } from '@mui/material/styles';
import themeTypography from './typography';
import themePalette from './palette';

/**
 * Represent theme style and structure as per Material-UI
 * @param {JsonObject} customization: customization parameter object
 */

export interface customization {
    fontFamily?: string;
    borderRadius?: number;
    mode?: 'light' | 'dark';
}

// declare module '@mui/material/styles' {
//     // allow configuration using `createTheme`
//     interface ThemeOptions {
//         customization?: {
//             fontFamily?: string;
//             borderRadius?: number;
//             mode?: 'light' | 'dark';
//         }
//     }
// }
const theme = (customization?: customization) => {
    const color: PaletteOptions = {
        primary: {
            light: '#2196f3',
            main: '#00b4e4',
            dark: '#1e88e5',
            200: '#90caf9',
            800: '#1565c0',
        },
        secondary: {
            light: '#ede7f6',
            main: '#2196f3',
            dark: '#5e35b1',
            200: '#b39ddb',
            800: '#4527a0',
        },
        error: {
            light: '#ef9a9a',
            main: '#f44336',
            dark: '#c62828'
        },
        warning: {
            light: '#fff8e1',
            main: '#ffe57f',
            dark: '#ffc107'
        },
        success: {
            light: '#b9f6ca',
            200: '#69f0ae',
            main: '#00e676',
            dark: '#00c853'
        },
        grey: {
            50: '#F8FAFC',
            100: '#EEF2F6',
            500: '#697586',
            600: '#4B5565',
            700: '#364152',
            900: '#121926',
        },
        text: {
            primary: '#202020',
            secondary: '#2F3857',
            disabled: '#EEF2F6',
        },
        background: {
            paper: '#EEEFEF',
            default: '#fff',
        },
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const themeOptions: ThemeOptions = {
        direction: 'ltr',
        palette: themePalette(color, customization),
        mixins: {
            toolbar: {
                minHeight: '48px',
                padding: '16px',
                color: '#fff',
                backgroundColor: '#46558C',
                '@media (min-width: 600px)': {
                    minHeight: '48px'
                }
            },
        },
        typography: themeTypography(color, customization)
    };

    const WashComponents = {
        MuiButton: {
            defaultProps: {
                disableElevation: true
            },
            styleOverrides: {                
                root: {
                    fontWeight: 400,
                    borderRadius: '50px',                    
                },
                contained: {
                    color: '#fff',
                },
            },
        },
    }

    const themes = createTheme(themeOptions);
    themes.components = WashComponents;

    return themes;
};

export default theme;